<footer class="bg-primary text-white">
  <div class="site-container grid grid-cols-1 gap-10 py-12 md:grid-cols-2 lg:grid-cols-4">
    <div class="space-y-6">
      <a routerLink="/" aria-label="Medviz, voltar ao início" class="inline-block">
        <img
          src="assets/images/logo/Medviz-color-logo-white.png"
          alt="Medviz"
          width="358"
          height="194"
          class="h-16 w-auto"
        />
      </a>
      <p class="max-w-xs text-xs leading-relaxed text-white/80">{{ content.tagline }}</p>
    </div>

    @for (column of content.columns; track column.title; let last = $last) {
      <div>
        <h2 class="mb-6 font-sans text-sm font-bold tracking-widest text-gold uppercase">{{ column.title }}</h2>
        <ul class="space-y-4 text-xs text-white/80">
          @for (link of column.links; track link.label) {
            <li>
              @if (link.section) {
                <a [appSectionLink]="link.section" class="transition-colors hover:text-gold">{{ link.label }}</a>
              } @else {
                <a [routerLink]="link.route" class="transition-colors hover:text-gold">{{ link.label }}</a>
              }
            </li>
          }
          @if (last) {
            <li class="flex gap-4 pt-4 text-gold">
              <app-icon name="shield_with_heart" />
              <app-icon name="verified_user" />
            </li>
          }
        </ul>
      </div>
    }
  </div>

  <div class="site-container">
    <div
      class="flex flex-col items-center justify-between gap-4 border-t border-white/10 py-8 text-[10px] font-bold tracking-widest text-white/60 uppercase md:flex-row"
    >
      <p>&copy; {{ currentYear }} {{ content.copyright }}</p>
      <span class="font-accent text-lg tracking-normal text-gold normal-case opacity-80">{{ content.signature }}</span>
    </div>
  </div>
</footer>
